#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query PurchaseOrderDetails($id: UUID!) {
  purchaseOrder(id: $id) {
    __typename
    id
    _purchaseOrderType
    businessUnit {
      name
    }
    sortSupplierName
    department {
      name
    }
    purchaseOrderDate
    currency {
      isoCode
      currencySymbol
    }
    controlTotalAmount
    reason
    description
    statusType {
      approvalState
    }
    _accountingStampDate
    _accountingStampTransactionReference
    _accountingStampUserName
    _isAccountingEntryStampedComplete
    _isTransactionCancelled
    stampedEntityDocumentId
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _rowTimestamp
        _createdDate
        createdByUser
      }
    }
    purchaseOrderHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
      totalCount
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
    purchaseOrderItems(orderBy: _SORT_ITEM_NUMBER_ASC) {
      nodes {
        id
        itemNumber
        displayPoItemType
        displayPoItemDescription
        displayPoItemAccount
        displayPoItemQuantity
        displayPoItemRentalTerm
        displayPoItemUnitPrice
        _extendedItemTotal
      }
    }
  }
}
